import { HelperWrapper, MainContainer, SuspensionWrapper } from 'src/components'

const ProfileSuspended = () => {
  return (
    <MainContainer headerTitle={<HelperWrapper t="profile-suspension-header-title" />}>
      <SuspensionWrapper>
        <HelperWrapper t="profile-suspension-title" />
        <br />
        <HelperWrapper t="profile-suspension-title-1" />
        &nbsp;
        <strong>info@trackgood.io</strong>.
      </SuspensionWrapper>
    </MainContainer>
  )
}

export default ProfileSuspended
